import { IconTypes } from './Icons'

export default function FriendIcon({
  fontSize = '1.6rem',
  rotate = 0,
  className = '',
  color = '#fff',
}: IconTypes) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      style={{
        width: '1em',
        height: '1em',
        fontSize,
        transform: `rotate(${rotate}deg)`,
      }}
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M7.63289 10.1832C7.60789 10.1832 7.59123 10.1832 7.56623 10.1832C7.52456 10.1748 7.46623 10.1748 7.41623 10.1832C4.99956 10.1082 3.17456 8.20817 3.17456 5.8665C3.17456 3.48317 5.11623 1.5415 7.49956 1.5415C9.88289 1.5415 11.8246 3.48317 11.8246 5.8665C11.8162 8.20817 9.98289 10.1082 7.65789 10.1832C7.64956 10.1832 7.64123 10.1832 7.63289 10.1832ZM7.49956 2.7915C5.80789 2.7915 4.42456 4.17484 4.42456 5.8665C4.42456 7.53317 5.72456 8.87484 7.38289 8.93317C7.43289 8.92484 7.54123 8.92484 7.64956 8.93317C9.28289 8.85817 10.5662 7.5165 10.5746 5.8665C10.5746 4.17484 9.19123 2.7915 7.49956 2.7915Z'
        fill={color}
      />
      <path
        d='M13.783 10.2918C13.758 10.2918 13.733 10.2918 13.708 10.2835C13.3663 10.3168 13.0163 10.0752 12.983 9.7335C12.9496 9.39183 13.158 9.0835 13.4996 9.04183C13.5996 9.0335 13.708 9.0335 13.7996 9.0335C15.0163 8.96683 15.9663 7.96683 15.9663 6.74183C15.9663 5.47516 14.9413 4.45016 13.6746 4.45016C13.333 4.4585 13.0496 4.17516 13.0496 3.8335C13.0496 3.49183 13.333 3.2085 13.6746 3.2085C15.6246 3.2085 17.2163 4.80016 17.2163 6.75016C17.2163 8.66683 15.7163 10.2168 13.808 10.2918C13.7996 10.2918 13.7913 10.2918 13.783 10.2918Z'
        fill={color}
      />
      <path
        d='M7.64134 19.2918C6.00801 19.2918 4.36634 18.8752 3.12467 18.0418C1.96634 17.2752 1.33301 16.2252 1.33301 15.0835C1.33301 13.9418 1.96634 12.8835 3.12467 12.1085C5.62467 10.4502 9.67467 10.4502 12.158 12.1085C13.308 12.8752 13.9497 13.9252 13.9497 15.0668C13.9497 16.2085 13.3163 17.2668 12.158 18.0418C10.908 18.8752 9.27467 19.2918 7.64134 19.2918ZM3.81634 13.1585C3.01634 13.6918 2.58301 14.3752 2.58301 15.0918C2.58301 15.8002 3.02467 16.4835 3.81634 17.0085C5.89134 18.4002 9.39134 18.4002 11.4663 17.0085C12.2663 16.4752 12.6997 15.7918 12.6997 15.0752C12.6997 14.3668 12.258 13.6835 11.4663 13.1585C9.39134 11.7752 5.89134 11.7752 3.81634 13.1585Z'
        fill={color}
      />
      <path
        d='M15.283 17.7917C14.9913 17.7917 14.733 17.5917 14.6746 17.2917C14.608 16.95 14.8246 16.625 15.158 16.55C15.683 16.4417 16.1663 16.2333 16.5413 15.9417C17.0163 15.5833 17.2746 15.1333 17.2746 14.6583C17.2746 14.1833 17.0163 13.7333 16.5496 13.3833C16.183 13.1 15.7246 12.9 15.183 12.775C14.8496 12.7 14.633 12.3667 14.708 12.025C14.783 11.6917 15.1163 11.475 15.458 11.55C16.1746 11.7083 16.7996 11.9917 17.308 12.3833C18.083 12.9667 18.5246 13.7917 18.5246 14.6583C18.5246 15.525 18.0746 16.35 17.2996 16.9417C16.783 17.3417 16.133 17.6333 15.4163 17.775C15.3663 17.7917 15.3246 17.7917 15.283 17.7917Z'
        fill={color}
      />
    </svg>
  )
}
